import { useState } from "react";
import { EyeOff } from "lucide-react";

export function Spoiler({ spoiler, children, id }) {
  const [show, setShow] = useState(false);
  if (!spoiler || show) return <div>{children}</div>;
  return (
    <div className="relative">
      <div className="pointer-events-none select-none blur-md" aria-hidden>{children}</div>
      <button data-testid={`reveal-spoiler-${id}`} onClick={() => setShow(true)}
        className="absolute inset-0 flex items-center justify-center gap-2 rounded-lg bg-black/40 text-sm font-semibold text-amber-300 hover:text-amber-200">
        <EyeOff className="h-4 w-4" /> Contains spoilers — Reveal
      </button>
    </div>
  );
}

export function Empty({ icon: Icon, title, text, action, testid }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center rounded-2xl border border-dashed border-white/10 bg-white/[0.02] px-6 py-12 text-center">
      {Icon && <Icon className="mb-3 h-8 w-8 text-amber-400/80" />}
      <p className="font-display text-2xl text-slate-100">{title}</p>
      {text && <p className="mt-1 max-w-md text-sm text-slate-400">{text}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Loading({ label = "Loading" }) {
  return (
    <div className="flex min-h-[40vh] items-center justify-center" data-testid="loading">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-amber-400 border-t-transparent" aria-label={label} />
    </div>
  );
}

export function ErrorBox({ text, retry }) {
  return (
    <div className="mx-auto my-16 max-w-md rounded-2xl border border-red-500/30 bg-red-500/5 p-6 text-center" data-testid="error-box">
      <p className="text-sm text-red-300">{text}</p>
      {retry && <button onClick={retry} className="mt-3 text-sm font-semibold text-amber-400">Try again</button>}
    </div>
  );
}

export function Avatar({ user, size = 36 }) {
  return user?.avatar ? (
    <img src={user.avatar} alt={`${user.username} avatar`} style={{ width: size, height: size }} className="rounded-full object-cover" />
  ) : (
    <span style={{ width: size, height: size }} className="flex items-center justify-center rounded-full bg-gradient-to-br from-purple-600 to-amber-500 text-sm font-bold uppercase text-white">
      {(user?.name || user?.username || "?")[0]}
    </span>
  );
}
